// src/redux/sagas/modifiersSaga.ts
import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
  fetchModifiersRequest,
  fetchModifiersSuccess,
  fetchModifiersFailure,
  ModifierGroup,
  ModifierOption,
} from '../slices/modifiersSlice';
import ENDPOINTS from '../../api/endpoints';
import { request } from '../../api/request';

function* fetchModifiersSaga(): Generator<any, void, any> {
  try {
    const groupsUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.MODIFIER_GROUPS_API_PATH}`;
    const optionsUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.MODIFIER_OPTIONS_API_PATH}`;

    // Fetch both APIs in parallel
    const [groupsResponse, optionsResponse] = yield all([
      call(request, {
        url: groupsUrl,
        method: 'GET',
      }),
      call(request, {
        url: optionsUrl,
        method: 'GET',
      }),
    ]);

    if (groupsResponse.data?.success && optionsResponse.data?.success) {
      yield put(
        fetchModifiersSuccess({
          groups: groupsResponse.data.data as ModifierGroup[],
          options: optionsResponse.data.data as ModifierOption[],
        })
      );
    } else {
      const errorMessage =
        groupsResponse.data?.message || optionsResponse.data?.message || 'Failed to fetch modifiers';
      yield put(fetchModifiersFailure(errorMessage));
    }
  } catch (error: any) {
    yield put(fetchModifiersFailure(error.message || 'Failed to fetch modifiers'));
  }
}

export function* modifiersSaga() {
  yield takeLatest(fetchModifiersRequest.type, fetchModifiersSaga);
}
